
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M30.455 7.545h3.272A3.273 3.273 0 0137 10.818v13.91A3.273 3.273 0 0133.727 28h-3.272v6.545L20.636 28h-3.272"}}),_c('path',{attrs:{"d":"M27.182 1H4.272A3.273 3.273 0 001 4.273v13.909a3.273 3.273 0 003.273 3.273h3.272v8.181L19 21.455h8.182a3.273 3.273 0 003.273-3.273V4.272A3.273 3.273 0 0027.182 1z"}})])])
          )
        }
      }
    